import { Route, Routes } from 'react-router';

import { KinetikSettingsRouteActions } from './actions/KinetikSettingsRouteActions';
import { MomentmSettingsRouteActions } from './actions/MomentmSettingsRouteActions';
import { MTMSettingsRouteActions } from './actions/MTMSettingsRouteActions';

export function AdminRouteActions() {
  return (
    <Routes>
      <Route element={<MTMSettingsRouteActions />} path="mtm" />
      <Route element={<MomentmSettingsRouteActions />} path="momentm" />
      <Route element={<KinetikSettingsRouteActions />} path="kinetik" />
    </Routes>
  );
}
